module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/avatars/13-small.png";